// Copyright (c) Docugami, Inc. All rights reserved.
import { ComparisonUnit } from "./ComparisonUnit";
import { DgXmlNames } from "./DgXmlNames";
import { StringBuilder } from 'utils/StringBuilder';

const charsToDisplay = 3; // Specifies the number of characters to display when dumping the element hierarchy, as in the comment following.  Normally 3 characters is enough to disambiguate.
                          // However, this is parameterized.  In case it is not, it is easy to change.
/*
CorrelatedSequence =====
  CorrelatedItem =====
    correlationStatus: Equal
    ComparisonUnitList =====
      ComparisonUnitToken: >PowerSuite<
        ComparisonUnitAtom: P Element: body[fc2]/p[47d]/r[58e]/t[87b]
        ComparisonUnitAtom: o Element: body[fc2]/p[47d]/r[58e]/t[87b]
        ComparisonUnitAtom: w Element: body[fc2]/p[47d]/r[58e]/t[87b]
                                            ^^^
                                            charsToDisplay
*/

export class ComparisonUnitAtom extends ComparisonUnit
{
    public contentCharacter: string;
    public contentElement: any;
    constructor(contentElement: any, contentCharacter: string)
    {
        super();
        this.contentCharacter = contentCharacter;
        this.contentElement = contentElement;
    }

    toString(): string
    {
        if (this.contentElement.parent === null) {
            const uuidAttValue = '[' + (this.contentElement.attribute(DgXmlNames.uuid)?.value.substring(0, charsToDisplay) || "???") + ']';
            const str = `  ComparisonUnitAtom: ${this.contentCharacter} RootElement: ${this.contentElement.name.localName + uuidAttValue}`;
            return str;
        }
        else
        {
            const ancestors = this.contentElement.ancestorsAndSelf().takeWhile((z: any) => z.name.localName !== 'document').reverse().toArray();
            const sb = new StringBuilder();
            ancestors.forEach((ancestor: any, i: number) =>
            {
                const uuidAttValue = '[' + (ancestor.attribute(DgXmlNames.uuid)?.value.substring(0, charsToDisplay) || "???") + ']';
                if (ancestor.name) {
                    sb.append(ancestor.name.localName + uuidAttValue);
                    if (i < ancestors.length - 1) {
                        sb.append("/");
                    }
                }
            });
            const str = `  ComparisonUnitAtom: ${this.contentCharacter} Element: ${sb.toString()}`;
            return str;
        }
    }
}
